import React from "react";

const ActionButton = ({ buttonText, onButtonClick }) => {
  return (
    <button
      className="text-primary bg-celadon p-2 px-3 sm:px-3 md:px-5 rounded-lg text-sm md:text-base"
      onClick={onButtonClick}
    >
      {buttonText}
    </button>
  );
};

export default ActionButton;
